import gql from 'graphql-tag'

export const fragmentUser = gql`
	fragment User on UserType {
		id
		email
		firstName
		lastName
		contractsFilter {
			id
			contractId
		}
		forcePasswordChange
		hasAcceptedLatestTermsOfUse
		hasPendingLicenseAgreements
		hasSelectedContracts
		helpFile
		isKasseUser
		isSuperuser
		isVswUser
		catalogTypes {
			id
			code
			displayTitle
			isHzvContractsSpecific
		}
	}
`
